<template>
  <div v-if="show" class="session-expired-modal-overlay" @click.self="handleOverlayClick">
    <div class="session-expired-modal">
      <div class="modal-header">
        <h4 class="modal-title">
          <i class="fa fa-exclamation-triangle" style="color: #f0ad4e; margin-right: 10px;"></i>
          세션이 만료되었습니다
        </h4>
      </div>
      <div class="modal-body">
        <p>보안을 위해 세션이 만료되었습니다. 다시 로그인해주세요.</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" @click="handleConfirm">
          확인
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionExpiredModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
    handleOverlayClick() {
      // Overlay 클릭해도 모달이 닫히지 않도록 아무 동작도 하지 않음
    },
    handleKeydown(event) {
      // ESC 키 무시
      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault()
        event.stopPropagation()
      }
    }
  },
  mounted() {
    // ESC 키로 모달이 닫히지 않도록 방지
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style scoped>
.session-expired-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.session-expired-modal {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e5e5e5;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
}

.modal-body {
  padding: 24px;
  color: #666;
  font-size: 1rem;
  line-height: 1.5;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: flex-end;
}

.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-primary:active {
  background-color: #004085;
}
</style>

